import React from 'react';
import { Row } from 'antd';

import { StyledRowHead, StyledRowInfo } from '../style';

export const RowInfo = ({ title, data }) => {
  const isArray = Array.isArray(data);
  return (
    <Row wrap={false}>
      <StyledRowHead>{title}:</StyledRowHead>
      <StyledRowInfo>
        {isArray && data?.length > 0 ? data?.join(', ') : (!isArray && data) || data === 0 ? String(data) : '-'}
      </StyledRowInfo>
    </Row>
  );
};
